import { useState, useEffect, useRef, useMemo } from 'react'
import axios from 'axios'
import moment from 'moment'
import {useLang} from '../components/LangProvider'
import {useDialog} from '../components/DialogProvider'
import {useAuth} from "./AuthProvider";

function RaceBlock({event}){

  // use first event race as selected by default
  // re-use race data or request if not found in existing set
  // participants will be requested again on race change (TODO add dedicated refresh button there ?)

  const [infoCount, setInfoCount] = useState(0)
  const [selectedRace, setSelectedRace] = useState(event.races[0].id)
  const [selectedInfo, setSelectedInfo] = useState(0)
  const [races, setRaces] = useState({})
  const [blocks, setBlocks] = useState(<>Loading...</>)
  const [trigger ,setTrigger] = useState(0)
  const [participants, setParticipants] = useState(<tr><td colSpan={7}> Getting up list ... </td></tr>)
  const {lang, t} = useLang()
  const raceContainer = useRef(null)
  const openDialog = useDialog()
  const {auth} = useAuth()

  // **** console.log("event given for raceBlocks:",event, selectedRace)

  /* some debug filler -> */
  const demoStr = (i) => <tr key={i}>
                    <td key={i+"-1"}>12345</td>
                    <td key={i+"-2"}>Testamonius Testov</td>
                    <td key={i+"-3"}>female</td>
                    <td key={i+"-4"}>2023</td>
                    <td key={i+"-5"}>15-19</td>
                    <td key={i+"-6"}>Kharkiv</td>
                    <td key={i+"-7"}>Some long-named running club Lorem ipsum dolor sit amet.</td>
                  </tr>
  const demoRows = () => {
    let i = 0
    let list = []
    while (i < 100) {
      list.push(demoStr(i))
      i++
    }
    return list
  }
  /* <- some debug filler */

  // update participants list if new race selected
  useEffect(() =>{

    let params = {
      race: selectedRace
    }

    axios({
      method: "get",
      url: process.env.REACT_APP_BACKEND_RACE_PARTICIPANTS,
      params: params,
      headers: {"Content-type": "application/json; charset=UTF-8"}
    })
      .then(res => {
          let i = 0
          let strings = res.data.map(competitor => {
            i++
            return<tr key={i}>
              <td key={i+"-1"}>{competitor.start_number}</td>
              <td key={i+"-2"}>{competitor.first_name} {competitor.last_name}</td>
              <td key={i+"-3"}>{competitor.gender ? 'M' : 'F'}</td>
              <td key={i+"-4"}>AGE ?</td>
              <td key={i+"-5"}>{competitor.age_category}</td>
              <td key={i+"-6"}>{competitor.city}</td>
              <td key={i+"-7"} className={competitor.is_captain ? 'class="capitan"' : null}>{competitor.club}</td>
            </tr>
          })
        setParticipants(strings)
        console.log('participants',res.data,strings,selectedRace)
        }
      )
      .catch(err => {
        console.log(err)
      })

  },[selectedRace])


  const Buttons = () => {
    let race = races[selectedRace]
    let result = []
    let i = 0

    // 1st btn always info
    result.push(
      <label htmlFor={"race-"+race.id+"-info"} key={"btn-"+i} className={selectedInfo === 0 ? "selected" : null} data-i={i}>
        <input type="radio" name="race-1" id={"race-"+race.id+"-info"} onChange={() => handleInfoSelect(0)} />
        <span>{lang["event info"]}</span>
      </label>)
    i++

    // 2nd - package
    if (race.hasOwnProperty('package')) {
      result.push(
        <label htmlFor={"race-" + race.id + "-package"} key={"btn-" + i}
               className={selectedInfo === 1 ? "selected" : null} data-i={i}>
          <input type="radio" name="race-1" id={"race-" + race.id + "-package"} onChange={() => handleInfoSelect(1)}/>
          <span>{lang["event package"]}</span>
        </label>)
      i++
    }

    // 3rd - map
    if (race.hasOwnProperty('map')) {
      result.push(
        <label htmlFor={"race-" + race.id + "-map"} key={"btn-" + i} className={selectedInfo === 2 ? "selected" : null}
               data-i={i}>
          <input type="radio" name="race-1" id={"race-" + race.id + "-map"} onChange={() => handleInfoSelect(2)}/>
          <span>{lang["event map"]}</span>
        </label>)
      i++
    }

    // removed ?
    // 4rd - regulations
    // if (race.hasOwnProperty('regulations')) {
    //   result.push(
    //     <label htmlFor={"race-" + race.id + "-regulations"} key={"btn-" + i}
    //            className={selectedInfo === 3 ? "selected" : null} data-i={i}>
    //       <input type="radio" name="race-1" id={"race-" + race.id + "-regulations"}
    //              onChange={() => handleInfoSelect(3)}/>
    //       <span>{lang["event regulations"]}</span>
    //     </label>)
    //   i++
    // }

    // 5..n text blocks from race texts
    let i_on_start = i
    if (race.text.length > 0) {
      race.text.forEach((text, j) => {
        result.push(
          <label htmlFor={"race-" + race.id + "-info-" + i}
                 key={"btn-" + i}
                 className={selectedInfo === (i_on_start + j) ? "selected" : null}
                 data-i={i}>
            <input type="radio"
                   name="race-1"
                   id={"race-" + race.id + "-info-" + i}
                   onChange={() => handleInfoSelect(i_on_start + j)}/>
            <span>{t(text.name)}</span>
          </label>
        )
        i++
      })
    }

    // last always event members
    result.push(
      <label htmlFor={"race-"+race.id+"-members"} key={"btn-"+i} className={selectedInfo === i ? "selected" : null} data-i={i}>
        <input type="radio" name="race-1" id={"race-"+race.id+"-members"} onChange={() => handleInfoSelect(i-1)} />
        <span>{lang["event members"]}</span>
      </label>
    )
    i++
    if (infoCount !== i) setInfoCount(i)
    return result
  }

  const Infos = () => {
    let race = races[selectedRace]
    let result = []
    let i = 0
    let infoInsert = <div className="race-info__description"></div>
    let registerBtn =<>
      <span className="race-info__price">{race.price} <span>uah</span></span>
      <button className="button-red-dashed"
              onClick={
                () => {
                  if (auth.isAuth){
                    openDialog("sign up",{event,race})
                  }else{
                    openDialog("register")
                  }
                } }>{lang["register"]}</button>
    </>

    // 1st - info
    if (race.hasOwnProperty('info')){
      infoInsert=<div className="race-info__description" key={"info-insert-1"} dangerouslySetInnerHTML={{__html: t(race.info.text) }}/>
    }
    console.log('button init auth',auth);
    result.push(<>
        <div className="race-info" data-i={i} key={"info-text-rid-" + race.id}>
          {infoInsert}
          <span className="race-info__registred">{race.participant_count}{race.members_max !== -1 ? ` / ${race.members_max}` : null}</span>
          <span className="race-info__start-time">{moment(race.date_start).format("HH:MM:SS")}</span>

          { (event.status === 1) ? registerBtn : null  }
        </div>
      </>
    )
    i++

    // 2nd - package
    if (race.hasOwnProperty('package')){
      result.push(
        <div className="race-text" key={"info-text-" + race.package.id} dangerouslySetInnerHTML={{__html: t(race.package.text) }} data-i={i}/>
      )
      i++
    }

    // 3rd - map
    if (race.hasOwnProperty('map')) {
      result.push(
        <div className="race-text" key={"info-text-" + race.map.id} dangerouslySetInnerHTML={{__html: t(race.map.text)}}
             data-i={i}/>
      )
      i++
    }
    // removed ?
    // 4rd - regulations
    // if (race.hasOwnProperty('regulations')) {
    //   result.push(
    //     <div className="race-text" key={"info-text-" + race.regulations.id}
    //          dangerouslySetInnerHTML={{__html: race.regulations.text}} data-i={i}/>
    //   )
    //   i++
    // }

    // 5..n text blocks from race texts
    if (race.text.length > 0) {
      race.text.forEach(text => {
        result.push(
          <div className="race-text" dangerouslySetInnerHTML={{__html: t(text.text)}} data-i={i}
               key={"info-text-" + text.id}/>
        )
        i++
      })
    }

    result.push(
      <div className="race-members" data-i={i} key={"info-participants-"+i}>
        <table className="race-members__table">
          <thead>
            <tr>
              <th>{lang["event members table header start number"]}</th>
              <th>{lang["event members table header name"]}</th>
              <th>{lang["event members table header sex"]}</th>
              <th>{lang["event members table header year"]}</th>
              <th>{lang["event members table header age category"]}</th>
              <th>{lang["event members table header city"]}</th>
              <th>{lang["event members table header club"]}</th>
            </tr>
          </thead>
          <tbody>
            {participants}
            {/*{demoRows()}*/}
          </tbody>
        </table>
      </div>
    )

    return result
  }

  function handleInfoSelect(info){
    //console.log('selected info set to',info)
    raceContainer.current.dataset.raceInfo = info
    setSelectedInfo(info)
    raceContainer.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }

  function getRaceButtons(event){
    let buttons = []
    event.races.forEach(race => {
      buttons.push(<>

          <label htmlFor={'race-' + race.id} key={event.id+"-"+race.id+"-btn"} className={selectedRace === race.id ? "selected" : null}>
            <input type="radio" name="races"  id={'race-' + race.id} checked={selectedRace === race.id ? true : false } onChange={() => {setSelectedInfo(0);setSelectedRace(race.id)}}/>
            <span >{t(race.name_short)}</span>
          </label>

        </> 
      )
    })
    return buttons;
  }

  useEffect(() => {
    console.log('useEffect block data',races,selectedRace,blocks)
    let race = races[selectedRace]
    let result = <></>

    if ( race !== null && race !== undefined ) {

      result = <>
        <div className="race-container" key={event.id+"-"+race.id+"-details"} data-race-info={selectedInfo} ref={raceContainer}>

          <div className="race-container__buttons" >
            <Buttons race={races[selectedRace]}/>
          </div>

          <div className="race-container__infos" style={{"--width":`calc(100% * ${infoCount})`}} key={event.id+"-"+race.id+"infos"}>
            <Infos race={races[selectedRace]}/>
          </div>
        </div>
      </>

    } else {
      result = <>Getting race info ...</>

      if (typeof timeout === "undefined") {
        let timeout = setTimeout(() => setTrigger(trigger + 1), 10)
      }else{
        return null
      }

      let params = {
        id: selectedRace
      }

      axios({
        method: "get",
        url: process.env.REACT_APP_BACKEND_RACE,
        params: params,
        headers: {"Content-type": "application/json; charset=UTF-8"}
      })
      .then(res => {
        let thisRace = res.data
        let newRaces = races
        newRaces[selectedRace] = thisRace
        setRaces(newRaces)
      })
      .catch(err => {
        console.log('error on race id ' + selectedRace + ' data request',err)
      })
    }

    setBlocks( result )
    console.log('updated on ' + selectedRace + ' and ',races)
  },[selectedRace, races, trigger, infoCount,participants])

  return <>
  <div className="container" key={"cont-"+event.id+"-"+races[selectedRace]?.id}>
    <div className="event-data">
      <div className="event-data__races-buttons">
        {getRaceButtons(event)}
      </div>

      <h1 className="events">{t(event.name)}</h1>
  
      <div className="event-data__race-data">
        {blocks}
      </div>
    </div>
  </div>
</>

}

export default RaceBlock